export const CACHE_KEY = 'lyrics-page';
